import { createContext, useContext } from 'react';

// ─────────────────────────────────────────────────────────────────
// The kind of document the canvas is editing
//
// Provided once by EditorCanvas so a BlockAdder nested in any container can
// offer the reusable components that target this kind, without threading the
// value through every block renderer. Undefined in the component designer,
// where components are never offered (no component-in-component).
// ─────────────────────────────────────────────────────────────────
export const DocumentKindContext = createContext<'post' | 'email' | undefined>(undefined);

export const useDocumentKind = () => useContext(DocumentKindContext);
